var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    {
      staticStyle: {
        padding: "30px 15px 30px 15px",
        "background-color": "#fff",
        margin: "0"
      }
    },
    [
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "privacy-unifi-title" }, [
                  _vm._v("Privacy Policy")
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "16px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "privacy-unifi-para font-w400" }, [
                  _vm._v(
                    "This policy describes how UNIFI AUSTRALIA Pty Ltd (ACN 669 133 377) (UNIFI, we, -us or our) collects, manages, stores, uses and discloses your personal information.  "
                  )
                ]),
                _vm._v(" "),
                _c("br")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-para font-w400 mt-12" },
                  [
                    _vm._v(
                      "It contains the broad privacy framework within which we operate, and should be read in conjunction with any:  ;\n          "
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [_vm._v("• supplementary privacy policies;")])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "• and implementation procedures, that we introduce or vary from time to time."
                    )
                  ])
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-para font-w400 mt-12" },
                  [
                    _vm._v(
                      "If you do not agree with the terms of this policy, please do not provide us with your personal information.\n          "
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-sub-title text-underline" },
                  [_vm._v("DEFINITIONS ")]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-para font-w400 mt-12" },
                  [
                    _vm._v(
                      "To explain some of the terminology which commonly appears in this policy:"
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-sub-title text-italic" },
                  [_vm._v("Information and Records")]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-para font-w400 mt-12" },
                  [
                    _vm._v(
                      "Information and records may be in electronic or hard copy form. This policy does not extend to information or records that are publicly available,\n            or that would constitute an “employee record” as defined by the Privacy Act 1988 (Cth) (Privacy Act).  "
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-sub-title text-italic" },
                  [_vm._v("Sensitive information")]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-para font-w400 mt-12" },
                  [
                    _vm._v(
                      "Sensitive information is an important type of personal information relating to your: "
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [_vm._v("• biometrics;")])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [_vm._v("• criminal record;")])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [_vm._v("• genetics;")])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [_vm._v("• health;")])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v("• membership of a political association;")
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "• membership of a professional or trade association; "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [_vm._v("• membership of a trade union;")])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [_vm._v("• philosophical beliefs;")])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [_vm._v("• political opinions;")])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [_vm._v("• racial or ethnic origin;")])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [_vm._v("• religious beliefs or affiliations;")])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [_vm._v("•  or sexual orientation or practices.")])
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-sub-title text-underline" },
                  [
                    _vm._v(
                      "HOW DOES UNIFI COLLECT AND HOLD PERSONAL INFORMATION? "
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-para font-w400 mt-12" },
                  [
                    _vm._v(
                      "We collect personal information in a number of ways, including:"
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [_vm._v("• directly from you,")])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [_vm._v("• via email,")])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [_vm._v("• telephone,")])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [_vm._v("• post,")])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v("• when you provide details for our mailing lists,")
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [_vm._v("• purchase our services,")])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v("• place a reservation for available properties,")
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [_vm._v("• participate in our promotions,")])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "• create a referral account for our website or when you join one of our clubs or programs;"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "• and from third parties to whom you make payments in connection with our reservations or services,\n              or to whom you provide personal details in connection with the receipt of marketing materials. This includes third parties who you authorise to provide us with personal information.  "
                    )
                  ])
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-sub-title text-italic" },
                  [_vm._v("Cookies")]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-para font-w400 mt-12" },
                  [
                    _vm._v(
                      "Our website uses ‘cookies’ to improve your browser experience.\n            Cookies are small text files that are downloaded and stored onto your computer’s browser directory when you visit a particular website.\n            By using our website, you consent to our use of cookies.  "
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-para font-w400 mt-12" },
                  [
                    _vm._v(
                      "Cookies are used to track the pages and services you visit on our website and to ensure that you are able to\n            move freely across our website without the need to re-enter information that you have already provided. "
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-para font-w400 mt-12" },
                  [_vm._v("We use cookies to collect information including: ")]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "• your computer’s IP address and other technical information;"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "• the date and time at which you access our website and the duration of your visit; "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v("• and the type of browser you are using.")
                  ])
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-para font-w400 mt-12" },
                  [
                    _vm._v(
                      "It is possible to disable cookies by adjusting your Internet browser’s setting, such that it refuses cookies. However,\n            our website may not function correctly in the event that your browser refuses cookies.\n            For an optimal browsing experience, we recommend that you allow the use of cookies.  "
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-sub-title text-italic" },
                  [_vm._v("Personal information")]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-para font-w400 mt-12" },
                  [
                    _vm._v(
                      "We will only solicit and collect personal information if:"
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "• it is reasonably necessary in order for us to provide our services and conduct our functions and activities;"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v("• or we are permitted to do so by law. ")
                  ])
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-sub-title text-italic" },
                  [_vm._v("Sensitive information")]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-para font-w400 mt-12" },
                  [
                    _vm._v(
                      "We will only solicit and collect sensitive information if:"
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "• we have your consent, and it is reasonably necessary for us to collect sensitive information to enable us to carry out relevant functions or activities; or  "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [_vm._v("• we are permitted to do so by law.")])
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-sub-title text-underline" },
                  [
                    _vm._v(
                      "WHAT TYPES OF PERSONAL INFORMATION DOES UNIFI COLLECT AND HOLD? "
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-para font-w400 mt-12" },
                  [
                    _vm._v(
                      "Depending upon how you interact with us, we may collect the following types of personal information from you:"
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [_vm._v("• your name, gender and date of birth;")])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [_vm._v("• your email address;")])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "• your occupation, job title and place of business;"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v("• the technology you use to access our services;")
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [_vm._v("• your residential and postal address;")])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [_vm._v("• telephone numbers;")])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "• your company name and Australian Business Number;"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v("• or your superannuation fund details. ")
                  ])
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-para font-w400 mt-12" },
                  [
                    _vm._v(
                      "You may refuse to provide personal information to us. However, if you exercise this right of refusal,\n            it may affect our ability to meet our obligations to you or to a third-party agency.  "
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-para font-w400 mt-12" },
                  [
                    _vm._v(
                      "You may also deal with us anonymously or by using a pseudonym. However,\n            if you do so, we may be prevented from providing you with accurate or useful information,\n            and you may not be able to access our full range of services.   "
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-sub-title text-underline" },
                  [
                    _vm._v(
                      "WHY DOES UNIFI COLLECT, HOLD, USE AND DISCLOSE PERSONAL INFORMATION?"
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-para font-w400 mt-12" },
                  [
                    _vm._v(
                      "We may collect, hold and use your personal information for a number of reasons including: "
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "• to provide information in relation to our services and available properties marketed for sale by our related companies and business associates,\n              including those we consider may be of interest to you in the future;  "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "•  to administer and manage processes which are key to our operations, such as processing reservations of available properties or orders for our services;  "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "• to effect the collection of money that you owe to us and to support auditing, compliance and other corporate governance functions;\n              to assess any application for employment during the recruitment process; to assess your creditworthiness;  "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "• to create an online referral account for you to access our website; "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "• to determine your eligibility for certain types of goods or services that may be of interest to you; "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "• to answer your queries, provide you with information you may have requested and generally conduct dealings with you; "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "• and to comply with legislative or other legal requirements. "
                    )
                  ])
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-para font-w400 mt-12" },
                  [
                    _vm._v(
                      "We may disclose your personal information for a number of reasons including:"
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "• to identify you and verify your age, identity and corporate information; "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "•   to provide our services to you, or the organisation that you represent;"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "• to improve our website and the services that we provide; "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [_vm._v("• to communicate with you; ")])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "• and for other purposes which are related, or directly related (in the case of sensitive information), to the purpose for which your information was initially collected."
                    )
                  ])
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-para font-w400 mt-12" },
                  [_vm._v("We may disclose your personal information to:")]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [_vm._v("• our related parties;   ")])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "•   to provide our services to you, or the organisation that you represent;"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "• other companies or individuals that assist us to provide our reservations and other services, "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "• other companies or individuals that assist us to provide our reservations and other services,"
                    )
                  ])
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-para font-w400 mt-12" },
                  [_vm._v("This includes: ")]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "• electronic transactions / payment service providers, to process reservations and other orders for our services;  "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "•   online booking service providers, to process bookings for our services;  "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "•  government authorities or other agencies where the disclosure is required or authorised by law; "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "• anyone else to whom you authorise us to disclose your personal information;  "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "• prospective purchasers of all or some of our business or assets, in the event of a merger, reorganisation or sale of our business or assets; "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "• information technology / cloud service providers, such as persons who develop any of the software used by our business;   "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "• and external business advisors, such as auditors and lawyers."
                    )
                  ])
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-para font-w400 mt-12" },
                  [
                    _vm._v(
                      "There are also a limited number of circumstances in which the Privacy Act permits us to use or disclose your personal information, without your consent.\n            An example of this is where the use or disclosure is necessary to prevent a serious and imminent threat to any person's life,\n            health or safety or a serious threat to public health or safety.  "
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-sub-title text-underline" },
                  [_vm._v("USE OF THIRD-PARTY SOFTWARE")]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-para font-w400 mt-12" },
                  [
                    _vm._v(
                      "As at 4/11/2024, our website uses the following services and technologies that are supplied by third\nparties:  "
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [_vm._v("• Stripe")])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [_vm._v("•  Mailchimp")])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [_vm._v("• Google Analytics")])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [_vm._v("• Meta")])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [_vm._v("• AWS")])
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-para font-w400 mt-12" },
                  [
                    _vm._v(
                      "Your personal information may be collected directly by the third-party providers of the abovementioned\nservices and technologies, when you input personal information via our website. You should review the\nprivacy policies of third parties who provide those technologies, to ensure that you are satisfied with the\nmanner in which they collect, manage, store, use and disclose your personal information. Except where\nwe state otherwise in this policy, those third parties’ dealings in your personal information are not\nsubject to our control and we are not sponsored, affiliated or associated with those providers.  "
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-sub-title text-underline" },
                  [_vm._v("DIRECT MARKETING")]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-para font-w400 mt-12" },
                  [
                    _vm._v(
                      "We may collect, store and use your personal information to market our services to you, where you have\nprovided your implied or express consent for us to do so. Consent may be implied when you have placed\na reservation or purchased services from us, joined one of our clubs or programs, entered into a\npromotion conducted by us, where you have subscribed to receive information from us or where you\nhave enquired about services that we provide. "
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-para font-w400 mt-12" },
                  [
                    _vm._v(
                      "You may always opt out of receiving marketing material by contacting our Privacy Officer or using the\nmethod that is provided in any of our electronic marketing communications to you. "
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-para font-w400 mt-12" },
                  [
                    _vm._v(
                      "We will not disclose your personal information to a third party for them to market their products or\nservices to you, without your consent. "
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-sub-title text-underline" },
                  [_vm._v("CROSS-BORDER DISCLOSURE OF PERSONAL INFORMATION")]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-para font-w400 mt-12" },
                  [
                    _vm._v(
                      "Personal information submitted on this website will be stored on the Cloud (that is, the internet). To\nassist UNIFI to store and access your personal information on the Cloud, UNIFI may store your personal\ninformation with, or allow it to be accessed by, overseas third parties who provide:"
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "1. Software and maintenance services for the Cloud;"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "2. Training services in connection with using and accessing the Cloud; and"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "3. Infrastructure / hardware used to access the Cloud. "
                    )
                  ])
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-para font-w400 mt-12" },
                  [
                    _vm._v(
                      "As those third parties are situated, and store content, offshore (including in jurisdictions such as\nBelgium, Chile, Denmark, Finland, Ireland, Netherlands, Singapore, Taiwan and the United States of\nAmerica), your personal information may be transmitted, disclosed, stored or accessed to and from\noverseas jurisdictions. "
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-para font-w400 mt-12" },
                  [
                    _vm._v(
                      "If you submit your personal information on this website, you are consenting to the transmission,\ndisclosure, storage and access of your personal information by third parties in overseas jurisdictions. In\nthat respect, APP 8 which ordinarily obliges UNIFI to take reasonable steps to ensure that overseas\nrecipients of your personal information do not breach the APPs (exceptAPP1) will not apply. "
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-para font-w400 mt-12" },
                  [
                    _vm._v(
                      "Please note that if any of those overseas recipients handle your personal information in a manner which\nis inconsistent, or does not comply, with the APPs: "
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "1. to the maximum extent permitted by law, UNIFI will not be accountable under the Privacy Act for\nany resulting loss or damage that you may suffer;"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "2. to the maximum extent permitted by law, you will not be able to seek redress against UNIFI\nunder the Privacy Act; "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "3. the overseas recipient may not be subject to any privacy obligations at all, or to any principles\nsimilar to the APPs; "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "4. you may not be able to seek redress against the overseas recipient in their jurisdiction; and "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "5. in holding your personal information, the overseas recipient may be subject to foreign laws which\ncompel their disclosure of your personal information to other parties, such as overseas\ngovernment authorities.  "
                    )
                  ])
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-sub-title text-underline" },
                  [
                    _vm._v(
                      "HOW DOES UNIFI HOLD AND SECURE YOUR PERSONAL INFORMATION?"
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-para font-w400 mt-12" },
                  [
                    _vm._v(
                      "We will take all reasonable steps to ensure the personal information we collect, use, or disclose is\naccurate, up to date, complete and relevant, having regard to the purpose of the collection, use or\ndisclosure. "
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-para font-w400 mt-12" },
                  [
                    _vm._v(
                      "You should ensure that any personal information you provide to us is both relevant and accurate. We\nhave in place user names, passwords and access restrictions that provide electronic protection of\npersonal information stored electronically. There are inherent risks with the transmission of data over\nthe internet. Whilst reasonably appropriate security measures are in place for the protection of your\npersonal information, you must be aware that no guarantee is made that your personal information is\ncompletely secure. We also secure hard copy personal information within buildings or other storage\nfacilities, by placing restrictions on access to those buildings or facilities (for example, by locking the\nbuildings and filing cabinets in which the personal information is stored)."
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-para font-w400 mt-12" },
                  [
                    _vm._v(
                      "In the event of any unauthorised access and/or disclosure of your personal information, we comply with\nour obligations under the Privacy Act in dealing with any such unauthorised access and/or disclosure,\nincluding any obligations which may arise in respect of eligible data breaches within the meaning of the\nPrivacy Act. "
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-sub-title text-underline" },
                  [
                    _vm._v(
                      "HOW CAN YOU ACCCESS AND SEEK CORRECTION OF YOUR PERSONAL INFORMATION?"
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-para font-w400 mt-12" },
                  [
                    _vm._v(
                      "We will deal with your requests for access or correction of your personal information, in accordance with\nthis policy. All requests must be made in writing, and in the appropriate form specified by us from time to\ntime. Within a reasonable timeframe after receiving your application, we will take reasonable steps to\ninform you of what personal information we hold. "
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-para font-w400 mt-12" },
                  [
                    _vm._v(
                      "We will ordinarily grant access to the personal information unless:"
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "• giving access would have an unreasonable impact on the privacy of other individuals;"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "•  the request for access is frivolous or vexatious;"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [
                    _vm._v(
                      "• we are entitled to reject your access to the personal information pursuant to any law; "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "privacy-unifi-para font-w700" }, [
                  _c("span", [_vm._v("• or the access would be unlawful.")])
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-para font-w400 mt-12" },
                  [
                    _vm._v(
                      "We reserve the right to charge a reasonable fee for providing access to the personal information, but not\nfor making the application or correcting personal information held by us. We may withhold access to the\npersonal information until the fee is paid. If you are of the view that your personal information requires\ncorrection, you should contact the Privacy Officer listed below. "
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-sub-title text-underline" },
                  [_vm._v("COMPLAINTS")]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-para font-w400 mt-12" },
                  [
                    _vm._v(
                      "If you believe that we have breached this policy, please contact our Privacy Officer by email at\nteam@unifiproperty.com or by mail to: Privacy Officer, 55 George Street, Norwood, South Australia 5067. "
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-para font-w400 mt-12" },
                  [
                    _vm._v(
                      "We take all complaints seriously and will respond to you within a reasonable period of time, unless we\nconsider your complaint to be frivolous, vexatious or without legal or factual merit. If you are not satisfied\nwith the way in which we have handled your complaint, you can make a complaint to the Australian\nInformation Commissioner. "
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-sub-title text-underline" },
                  [_vm._v("MORE INFORMATION")]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "privacy-unifi-para font-w400 mt-12" },
                  [
                    _vm._v(
                      "If you have any questions or require further information please contact our Privacy Officer by e-mail at\nteam@unifiproperty.com."
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-02224064", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02224064","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/privacyPolicy/privacyPolicyContent.vue
// module id = null
// module chunks = 